import { call, put, takeLatest } from "redux-saga/effects";
import {
  updateExpensesListTotal,
  updateExpensesList,
  deleteExpensesList,
} from "../slices/expensesSlice";
import { setData } from "../slices/expensesListsSlice";
import { api } from "../utils/api";

function* refreshExpensesListsSaga() {
  try {
    const { data: expensesLists } = yield call(api.getExpensesLists);
    yield put(setData(expensesLists));
    console.log("Expenses Lists refreshed:", expensesLists);
  } catch (error) {
    console.error("Failed to Expenses Lists", error);
  }
}

export default function* expensesListsSaga() {
  yield takeLatest(
    [
      updateExpensesListTotal.type,
      deleteExpensesList.type,
      updateExpensesList.type,
    ],
    refreshExpensesListsSaga
  );
}
